import { motion } from "framer-motion";
import HandshakeIcon from "@mui/icons-material/Handshake";
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import FeedIcon from '@mui/icons-material/Feed';
import { useNavigate } from "react-router-dom";

export default function AboutSection() {
   const navigate = useNavigate();
  return (
   <section className="bg-gray-100 pt-4 pb-6"> {/* less top and add some bottom padding */}
  <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-4">

<div className="relative flex items-center gap-3 md:w-1/2 w-full lg:w-1/3">
  <motion.div
    className="w-full aspect-w-4 aspect-h-3 md:h-56 rounded-lg overflow-hidden shadow-lg"
    initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
  >
    <img
      src="/assets/Talentacq.webp"
      alt="Dereja Journey"
      className="w-full h-full object-cover rounded-lg"
    />
  </motion.div>

  <motion.div
    className="absolute bottom-3 left-3 md:bottom-6 md:left-6 bg-gradient-to-r from-white to-gray-100 shadow-lg rounded-lg p-3 flex items-center gap-2 cursor-pointer
               transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-orange-400/60"
    initial={{ opacity: 0, scale: 0.8 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.6, delay: 0.3 }}
    whileHover={{ scale: 1.1 }}
  >
    <span className="inline-block w-3 h-3 mr-1 rounded-full bg-orange-500 animate-pulse"></span>
    <span className="text-xl font-extrabold text-orange-500 leading-none select-none">5+</span>
    <span className="text-gray-700 text-sm leading-tight select-none">Years of Experience</span>
  </motion.div>
</div>

    <div className="md:w-1/2 mt-6 md:mt-0 md:pl-6 text-left"> {/* less top margin and padding */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >

        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4"> {/* smaller heading */}
          Empowering Graduates, Shaping Futures
        </h2>
        <p className="text-gray-600 mb-3 leading-relaxed text-justify text-sm md:text-base"> {/* smaller text */}
          Since 2017, Dereja has been on a mission to bridge the gap between
          Ethiopian graduates and the world of work. Through nationwide
          career readiness programs, mentorship, and strategic employer
          partnerships, we have connected <strong>109,616+</strong> young
          professionals with meaningful employment opportunities turning
          aspirations into thriving careers.
        </p>
        <button
          className="bg-orange text-white py-1.5 px-5 rounded-md font-semibold hover:bg-orange transition duration-300 text-sm"
          onClick={() => navigate('/learnmore')}
        >
          Read More ...
        </button>
      </motion.div>

      <div className="relative mt-6 ml-4"> {/* less margin top and left */}
        <div className="absolute top-0 h-full border-l-2 border-dotted bg-orange"></div>

        {[
          {
            title: "Career Readiness & Capacity Building",
            description:
              "We equip students and graduates with essential soft skills, professional training, and mentorship to enhance their employability and career growth.",
            icon: <HandshakeIcon className="w-5 h-5" />,
          },
          {
            title: "Job Matching & Internship Placement",
            description:
              "We connect graduates with the right opportunities by facilitating job matching and internship placements through our employer network.",
            icon: <WorkHistoryIcon className="w-5 h-5" />,
          },
          {
            title: "Information Access & Career Support Platforms",
            description:
              "We provide graduates with access to curated job platforms, career resources and tools while partnering with 250+ employers to facilitate meaningful employment.",
            icon: <FeedIcon className="w-5 h-5" />,
          },
        ].map((item, index) => (
          <motion.div
            key={index}
            className="flex items-start gap-3 mb-5 mx-2"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <div className="w-6 h-6 text-orange flex items-center justify-center rounded-full text-sm font-semibold mt-1">
              {item.icon}
            </div>
            <div>
              <h3 className="font-semibold text-md text-gray-800">{item.title}</h3>
              <p className="text-gray-600 leading-snug text-justify text-sm">{item.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </div>
</section>

  );
}
